import React from 'react';
import { Page } from 'react-onsenui';
import * as sdkclaro from '@claro/sdkclaromicrofront'
import PlansContainer from "../containers/PlansContainer"

const TelcelPlansIdPage = ({ match, location, history  }) => {
    const { 
        state: { 
            sdkVersion, 
            paymentsConfig, 
            isClaroPartner,
            serviceConfigIndex,
            tagServiceId,
            isContainerTelcel
        }
    } = location;
    sdkclaro.getInstance().switchGoBackButton(true)
    return (
        <Page id="telcel-plans-page">
            <PlansContainer
                serviceConfigIndex={serviceConfigIndex} 
                sdkVersion = {sdkVersion} 
                paymentsConfig = {paymentsConfig} 
                isClaroPartner = {isClaroPartner}
                tagServiceId={tagServiceId}
                history = {history}
                isContainerTelcel={isContainerTelcel}
            />
        </Page>    
  );
};


export default TelcelPlansIdPage